import { dateFormat, dateTimeFormat } from '../../../utils';

interface Props {
    date: string;
    showTime: boolean;
}

export const DateTimeLabel = ({ date, showTime = false }: Props) => {
    if (!date) {
        return <span className='text-muted'> </span>;
    }
 
    return (
        <span className='text-muted'>
            {showTime
                ? dateTimeFormat(date).toString()
                : dateFormat(date).toString()}
        </span>
    );
};
